import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field, reduxForm, getFormValues} from 'redux-form';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import SearchIcon from '@mui/icons-material/Search';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import AddIcon from '@mui/icons-material/Add';
import {withStyles} from '@mui/styles';
import {FormControl, FormGroup} from '@mui/material';
import {HttpStatusCode} from 'axios';
import {searchMap, searchCheck} from '../../../../common/common.js';
import {GMN, GMN_PATH, CATEGORY_TYPE, CORP_CD, OPERATION_PERMISSION_TYPE, USER_TYPE_CODE} from '../../../../common/commonConst.js';
import {commonOperations} from '../../../../reducks/common';
import MainContainer from '../../../organisms/MainContainer.js';
import {renderTextField, renderSelect, renderCheckbox} from '../../../atoms/CustomPart.js';
import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
import PaperPart from '../../../atoms/PaperPart.js';
import withRouter from '../../../organisms/withRouter.js';
import {setSessionObject} from '../../../../common/Session.js';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
import CustomFlexGrid, {createComponents} from '../../../molecules/CustomFlexGrid.js';
import {postRequest} from '../../../../common/backend.js';
import CustomAccordion from '../../../molecules/Accordion.js';
import {sysErr, getKbnList} from '../../../../common/commonGmn.js';
import CustomBreadcrumbs from '../../../molecules/Breadcrumbs.js';
// パンくずパラメータ
const transitionList = [
  {gmnName: GMN.MENU.name, href: GMN_PATH.MENU},
  {gmnName: GMN.USER_MASTER_LIST.name, href: ''},
];

const styles = (theme) => ({

});
// ユーザー一覧管理
const userListViews = [
  {binding: 'userId', header: 'ユーザID', dataType: 'link', width: 110, visible: true},
  {binding: 'userNm', header: 'ユーザ氏名', dataType: 'String', width: 150, isReadOnly: true, visible: true},
  {binding: 'userNmkn', header: 'ユーザ氏名カナ', dataType: 'String', width: 110, isReadOnly: true, visible: true},
  {binding: 'abbrUserNm', header: 'ユーザ略名', dataType: 'String', width: 110, isReadOnly: true, visible: true},
  {binding: 'corp', header: '会社', dataType: 'String', width: 130, isReadOnly: true, visible: true},
  {binding: 'dig4Zgsyo', header: 'NW事業所', dataType: 'String', width: 110, isReadOnly: true, visible: true},
  {binding: 'surveyAgencyOffice', header: '調査機関事業所', dataType: 'String', width: 110, isReadOnly: true, visible: true},
  {binding: 'yukoStartYmd', header: '有効開始年月日', dataType: 'String', width: 100, isReadOnly: true, visible: true},
  {binding: 'yukoEndYmd', header: '有効終了年月日', dataType: 'String', width: 100, isReadOnly: true, visible: true},
  {binding: 'userType', header: 'ユーザ種別', dataType: 'String', width: 110, isReadOnly: true, visible: true},
  {binding: 'mailaddress', header: 'メールアドレス', dataType: 'String', width: 150, isReadOnly: true, visible: true},
  {binding: 'noticeTarget', header: '通知対象', dataType: 'Boolean', width: 70, isReadOnly: true, visible: true},
  {binding: 'prefCode', header: '県', dataType: 'String', width: 70, isReadOnly: true, visible: false},
  {binding: 'corpCd', header: '会社コード', dataType: 'String', width: 70, isReadOnly: true, visible: false},
];

/**
 *  ユーザ一覧画面
 * 画面ID:SCZ1003
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      nwOfficeDisabled: false,
      surveyAgencyOfficeDisabled: false,
      corpDisabled: false,
      warningMessages: [],
      userRoleCdList: [],
    };

    this.gridRef = React.createRef();
    this.setGridItems();
    this.userRoleList={};
    this.isVisible=false;
  }
  /**
     * 画面項目設定
     */
  setGridItems = () => {
    let views = userListViews;
    views.forEach((view) => {
      if (view.binding=='userId') {
        view.click = (e, ctx) => {
          this.doEditLink(ctx.item.userId, ctx.item.corpCd, ctx.item.prefCode);
        };
      }
    });
  };

  /**
   * 初期処理
   */
  async componentDidMount() {
    this.initialValue();
  }

  async initialValue() {
    const {userInfo, genericMap, menuItems} = this.props;
    let initItems = {};
    initItems['corp'] =userInfo.corpCd;
    initItems['dig4Zgsyo'] =userInfo.nwOfficeCode;
    initItems['surveyAgencyOffice'] =userInfo.surveyAgencyOfficeCode;
    this.userRoleList = searchMap(
        genericMap, CATEGORY_TYPE.USER_TYPE_CODE);
    this.listSet(userInfo.corpCd);
    if (userInfo.corpCd!==CORP_CD.CBID_USER) {
      this.setState({'corpDisabled': true});
    }
    this.isVisible = menuItems.some(
        (item) => item.gamenId === GMN.USER_MASTER_LIST.gmnId &&
                  item.operationPermissionType ===
                      OPERATION_PERMISSION_TYPE.EXECUTE);    // 実行権限
    try {
      this.props.change('corp', initItems['corp'] );
      this.props.change('dig4Zgsyo', initItems['dig4Zgsyo'] );
      this.props.change('surveyAgencyOffice', initItems['surveyAgencyOffice'] );
      this.gridRef.current.setItemsSource(null);
    } catch (error) {
      sysErr(this.props);
    }
  }

  /**
     * 終了処理
     */
  async componentWillUnmount() {
    this.props.reset();
    this.props.doSetInitValues(null);
    this.gridRef.current.setItemsSource(null);
  }

  /**
   * 検索処理
   */
  _searchUser = async () => {
    try {
      const {values, userInfo} = this.props;
      let searchNwCodes = [];
      if (values.dig4Zgsyo == null||values.dig4Zgsyo == '') {
        searchNwCodes=userInfo.authNwOfficeCodes;
      } else {
        searchNwCodes=[values.dig4Zgsyo];
      }
      let searchAgencyCodes = [];
      if (values.surveyAgencyOffice == null||values.surveyAgencyOffice == '') {
        searchAgencyCodes=userInfo.authSurveyAgencyOfficeCodes;
      } else {
        searchAgencyCodes=[values.surveyAgencyOffice];
      }
      let _body = {
        searchConditionModel: values,
        surveyCompanyCode: userInfo.corpCd,
        nwOfficeCodes: searchNwCodes,
        surveyAgencyCodes: searchAgencyCodes,
      };
        // リクエスト出す
      const response = await postRequest('scz1003/search-user-master-list', _body);

      if (response.status != HttpStatusCode.Ok) {
        if (response.data?.message != null) {
          this.props.doShowMessage({
            message: {
              id: response.data?.message.id,
              text: response.data?.message.text,
            },
          });
        }
        return;
      }
      let _warningMessages = searchCheck(response.data.userInfoList);
      this.setState({warningMessages: _warningMessages});
      if (this.gridRef?.current) {
        this.gridRef.current.setItemsSource(
            response.data.userInfoList);
      }
    } catch (error) {
      sysErr(this.props);
    }
    return true;
  };

  /**
   * クリア処理
   */
  _reset = async () => {
    await this.props.reset();
    await this.initialValue();
    this.gridRef.current.setItemsSource(null);
  };

  /**
   * 検索ボタン押下時処理
   */
  doSearch = async () => {
    this._searchUser();
  };

  /**
   * 一覧表示
   * @return {object}
   */
  renderTable() {
    const props = {
      rowHeaderType: 'None',
      id: 'SCZ1003Table',
      filterOn: true,
      headersVisibility: 'Column',
      allowDragging: 'Columns',
      allowSorting: 'SingleColumn',
      AddDeleteOn: false,
      style: {maxHeight: '300pt', maxWidth: '100%', height: 'auto', width: 'auto'},
      isReadOnly: true,
      isDisplayCount: true,
    };
    const component = createComponents(userListViews, true);
    return (
      <CustomFlexGrid ref={this.gridRef} {...props}>
        {component}
      </CustomFlexGrid>
    );
  }

  /**
   * 一覧リンククリック時
   * @param {*} userId ユーザID
   * @param {*} corpCd 会社コード
   * @param {*} prefCode 県コード
   */
  doEditLink = async (userId, corpCd, prefCode) => {
    try {
      let params = {
        userId: userId,
        company: corpCd,
        prefCode: prefCode,
        transitionList: transitionList,
      };
      params.transitionList[1].href = GMN_PATH.USER_MASTER_LIST;
      // ユーザ詳細画面に遷移
      setSessionObject(GMN.USER_MASTER_INFO.id, params);
      this.props.navigate(GMN_PATH.USER_MASTER_INFO);
    } catch (error) {
      sysErr(this.props);
    }
  };

  /**
   * 会社変更
   * @param {*} e
   * @param {*} v
   */
  corpChange = (e, v) => {
    if (v==='') {
      this.setState({'userRoleCdList': getKbnList(this.userRoleList)});
      this.setState({'surveyAgencyOfficeDisabled': false});
      this.setState({'nwOfficeDisabled': false});
    } else {
      this.listSet(v);
    }
  };

  /**
   * 会社変更
   * @param {*} value
   */
  listSet(value) {
    if (value==='') {
      this.setState({'userRoleCdList': getKbnList(this.userRoleList)});
      this.setState({'surveyAgencyOfficeDisabled': false});
      this.setState({'nwOfficeDisabled': false});
    } else {
      let filteredUserRole = this.userRoleList.filter((item) =>
        item.valueString1 === value);
      this.setState({'userRoleCdList': getKbnList(filteredUserRole)});
      if (value===CORP_CD.CBID_USER) {
        this.setState({'surveyAgencyOfficeDisabled': true});
        this.setState({'nwOfficeDisabled': false});
        this.props.change('surveyAgencyOffice', '');
      } else {
        this.setState({'nwOfficeDisabled': true});
        this.setState({'surveyAgencyOfficeDisabled': false});
        this.props.change('dig4Zgsyo', '' );
      }
    }
  }

  /**
   * 検索条件タブの要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  renderCondition() {
    let isReadOnly = false;
    const {
      genericMap, userInfo,
    } = this.props;
    const corpList = searchMap(
        genericMap, CATEGORY_TYPE.CORP_CD);
    let corpCdList;
    // ユーザ権限より会社リスト取得
    let targetCorp = corpList.filter(
        (item) => userInfo.authCorpCodes.includes(item.cd));
    corpCdList= getKbnList(targetCorp);

    // ユーザ権限より調査機関リスト取得
    const zityousyaList = searchMap(
        genericMap, CATEGORY_TYPE.SURVEY_AGENCY_OFFICE_CODE);
    let targetZityousya = zityousyaList.filter(
        (item) => userInfo.authSurveyAgencyOfficeCodes.includes(item.cd));
    let zityousyaCodeList= getKbnList(targetZityousya);


    // ユーザ権限よりNW事業所リスト取得
    const nwList = searchMap(
        genericMap, CATEGORY_TYPE.NW_OFFICE_CODE);
    let targetNwList =[];
    // 本社ユーザの場合
    if (userInfo.userTypeCode===USER_TYPE_CODE.SYSTEM_KANRI ||
      userInfo.userTypeCode===USER_TYPE_CODE.HONSYASYSTEM_KANRI ||
    userInfo.userTypeCode===USER_TYPE_CODE.HONSYAGYOMU_KANRI) {
      targetNwList=nwList;
    } else {
      targetNwList=nwList.filter(
          (item) => userInfo.authNwOfficeCodes.includes(item.cd));
    }
    let nwCodeList = getKbnList(targetNwList);

    return (
      <React.Fragment>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="corp" item xs={12} sm={2}>
            <Field
              id="corp"
              name="corp"
              component={renderSelect}
              className="fields"
              label="会社"
              fullWidth
              required={false}
              validate={[
              ]}
              disabled={this.state.corpDisabled}
              onChange={this.corpChange}
              InputProps={{
                readOnly: isReadOnly,
                shrink: true,
              }}
            >
              {corpCdList}
            </Field>
          </Grid>
          <Grid key="dig4Zgsyo" item xs={12} sm={2}>
            <Field
              id="dig4Zgsyo"
              name="dig4Zgsyo"
              component={renderSelect}
              className="fields"
              label="NW事業所"
              fullWidth
              required={false}
              validate={[
              ]}
              disabled={this.state.nwOfficeDisabled}
              InputProps={{
                readOnly: isReadOnly,
                shrink: true,
              }}
            >
              {nwCodeList}
            </Field>
          </Grid>
          <Grid key="surveyAgencyOffice" item xs={12} sm={2}>
            <Field
              id="surveyAgencyOffice"
              name="surveyAgencyOffice"
              component={renderSelect}
              className="fields"
              label="調査機関事業所"
              fullWidth
              required={false}
              disabled={this.state.surveyAgencyOfficeDisabled}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
                shrink: true,
              }}
            >
              {zityousyaCodeList}
            </Field>
          </Grid>
          <Grid key="userId" item xs={12} sm={2}>
            <Field
              id="userId"
              name="userId"
              component={renderTextField}
              className="fields"
              label="ユーザID"
              fullWidth
              type="text"
              required={false}
              validate={[
              ]}
            />
          </Grid>
          <Grid key="userNm" item xs={12} sm={2}>
            <Field
              id="userNm"
              name="userNm"
              component={renderTextField}
              className="fields"
              label="ユーザ氏名"
              fullWidth
              type="text"
              required={false}
              validate={[
              ]}
            />
          </Grid>
          <Grid key="userNmkn" item xs={12} sm={2}>
            <Field
              id="userNmkn"
              name="userNmkn"
              component={renderTextField}
              className="fields"
              label="ユーザ氏名カナ"
              fullWidth
              type="text"
              required={false}
              validate={[
              ]}
            />
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >
          <Grid key="abbrUserNm" item xs={12} sm={2}>
            <Field
              id="abbrUserNm"
              name="abbrUserNm"
              component={renderTextField}
              className="fields"
              label="ユーザ略名"
              fullWidth
              type="text"
              required={false}
              validate={[
              ]}
            />
          </Grid>
          <Grid key="userType" item xs={12} sm={2}>
            <Field
              id="userType"
              name="userType"
              component={renderSelect}
              className="fields"
              label="ユーザ種別"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
                shrink: true,
              }}
            >
              {this.state.userRoleCdList}
            </Field>
          </Grid>
          <Grid key="mailaddress" item xs={12} sm={2}>
            <Field
              id="mailaddress"
              name="mailaddress"
              component={renderTextField}
              className="fields"
              label="メールアドレス"
              fullWidth
              type="text"
              required={false}
              validate={[
              ]}
            />
          </Grid>

          <Grid key="historySearch" item xs={12} sm={2}>
            <FormControl component="fieldset" className="formControl">
              <FormGroup row={true}>
                <Field className="checkbox"
                  id="historySearch"
                  name="historySearch"
                  component={renderCheckbox}
                  label="有効期限切れ"
                  onChange={this._handleChangeCheckbox}
                  validate={[]}
                  sx={{marginLeft: '20px'}}
                />
              </FormGroup>
            </FormControl>
          </Grid>
          <Grid key="noticeTarget" item xs={12} sm={2}>
            <FormControl component="fieldset" className="formControl">
              <FormGroup row={true}>
                <Field className="checkbox"
                  id="noticeTarget"
                  name="noticeTarget"
                  component={renderCheckbox}
                  label="通知対象"
                  onChange={this._handleChangeCheckbox}
                  validate={[]}
                  sx={{marginLeft: '20px'}}
                />
              </FormGroup>
            </FormControl>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };

  /**
   * フッタボタン
   * @return {JSX.Element}
   */
  renderFooterBtn() {
    return (
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        spacing={1}
      >
        {this.isVisible && <Grid key="keySCZ1003Create" item>
          <PositiveButton
            id="keySCZ1003Create"
            onClick={this.doTenNext}
            variant="contained"
            startIcon={<AddIcon />}
          >
            <span>新規作成</span>
          </PositiveButton>
        </Grid>
        }
      </Grid>
    );
  };
  /**
   * 新規作成ボタン押下時
   */
  doTenNext = async () => {
    try {
      let params = {
        userId: '',
        transitionList: transitionList,
      };
      params.transitionList[1].href = GMN_PATH.USER_MASTER_LIST;
      // ユーザ詳細画面に遷移
      setSessionObject(GMN.USER_MASTER_INFO.id, params);
      this.props.navigate(GMN_PATH.USER_MASTER_INFO);
    } catch (error) {
      sysErr(this.props);
    }
  };

  render() {
    // フッタボタンを生成
    const footerBtn = this.renderFooterBtn();
    return (
      <form noValidate autoComplete="off" className="bf-form-root">
        <MainContainer
          props={this.props}
          footerBtn={footerBtn}
        >
          <CustomBreadcrumbs key="keyBreadcrumbs" items={transitionList}/>
          <Grid key="keySCZ1003Msg" item xs={12}>
            <WarningMessageArea messages={this.state.warningMessages}/>
          </Grid>
          <PaperPart>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={1}
            >
              <Grid key="search" item xs={12}>
                <CustomAccordion title='検索条件' items={[this.renderCondition()]} defaultExpanded={true}/>
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="right"
              alignItems="right"
            >
              <Grid key="clear" item>
                <NegativeButton
                  id="clear"
                  variant="contained"
                  startIcon={<RotateLeftIcon />}
                  className="button_list"
                  size="middle"
                  onClick={this._reset}
                >
                  <span>クリア</span>
                </NegativeButton>
              </Grid>
              <Grid key="search" item>
                <PositiveButton
                  id="search"
                  variant="contained"
                  startIcon={<SearchIcon />}
                  className="button_list"
                  size="middle"
                  onClick={this.doSearch}
                >
                  <span>検索</span>
                </PositiveButton>
              </Grid>
            </Grid>
          </PaperPart>
          <div style={{marginBottom: '20px'}} />
          <Divider variant="middle" />
          <div style={{marginBottom: '20px'}} />
          <Grid container
            justifyContent="flex-start"
            alignItems="flex-end"
            spacing={1}
            direction={'row'}
            style={{marginLeft: '0px'}}
          >
            {this.renderTable()}
          </Grid>
        </MainContainer>
      </form>
    );
  }
}

Container.propTypes = {
  classes: PropTypes.object,
  values: PropTypes.object,
  userInfo: PropTypes.object,
  reset: PropTypes.func,
  navigate: PropTypes.func,
  genericMap: PropTypes.object,
  change: PropTypes.func,
  doShowMessage: PropTypes.func,
  doSetInitValues: PropTypes.func,
  menuItems: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    userInfo: state.auth.userInfo,
    genericMap: state.common.generalPurposeMap,
    initialValues: {},
    menuItems: state.auth.menuItems,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doSetInitValues: commonOperations.doSetInitValues,
};

const FORM_NAME = 'SCZ1003FORM';

Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Container));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Container)),
);
